const sellerReceiptEventCategory = "DIY_seller_receipt";

export const postInspectionDiyViewMoreClicked = {
    event: "diy_view_more_clicked"
};

export const postInspectionDiyPriceProceedClicked = {
    event: "diy_price_proceed_clicked"
};

export const postInspectionDiyFaqClicked = {
    event: "diy_faq_clicked"
};

export const postInspectionDiyConnectWithRa = {
    event: "connect_with_ra"
};

export const postInspectionDiyPaiOcbPageView = {
    event: "diy_pai_ocb_page_view",
    eventCategory: "DIY_Price_nego"
};

export const postInspectionDiyAuctionInProgressPageLoaded = {
    eventCategory: "DIY_Auction",
    event: "auction_in_progress_page_loaded",
    eventAction: "Auction in progress page loaded"
};

export const postInspectionDiyDocUpload = {
    event: "diy_doc_upload",
    eventCategory: "DIY_doc_upload"
};

export const postInspectionDiyPickup = {
    event: "diy_pickup",
    eventCategory: "DIY_pickup"
};

export const sellerReceiptPageViewed = {
    eventCategory: sellerReceiptEventCategory,
    event: "seller_receipt_page_viewed",
    eventAction: "General Seller Receipt Page Loaded"
};

export const sellerReceiptCardSelection = {
    eventCategory: sellerReceiptEventCategory,
    event: "seller_receipt_card_selection"
};

export const sellerReceiptWhatIsNextSelection = {
    eventCategory: sellerReceiptEventCategory,
    event: "seller_receipt_what_is_next"
};

export const challanImageSelection = {
    eventCategory: sellerReceiptEventCategory,
    event: "challan_image_selection"
};

export const holdbacksDocUploadClicked = {
    eventCategory: sellerReceiptEventCategory,
    event: "holdbacks_doc_upload_clicked"
};

export const holdbacksDocUploadError = {
    eventCategory: sellerReceiptEventCategory,
    event: "holdbacks_doc_upload_error"
};

export const docUploadCommon = {
    eventCategory: "DIY_doc_upload"
};

export const kavachBannerViewed = {
    eventCategory: "Seller_Kavach",
    event: "kavach_view",
    eventAction: "kavach_view_web_car_hand"
};

export const kavachBannerClicked = {
    eventCategory: "Seller_Kavach",
    event: "kavach_click",
    eventAction: "kavach_banner_click_web_car_hand"
};

export const kavachBannerlandingView = {
    eventCategory: "Seller_Kavach",
    event: "kavach_view",
    eventAction: "kavach_view_web_landingpage"
};

export const kavachAppDownload = {
    eventCategory: "Seller_Kavach",
    event: "kavach_click",
    eventAction: "kavach_web_download"
};

export const kavachKnowMoreBottomSheet = {
    eventCategory: "Seller_Kavach",
    event: "kavach_click",
    eventAction: "kavach_info_click_web_bottomsheet"
};
